import { createContext } from 'utils/react-helpers';

const [ProductProvider, useProduct] = createContext({ name: 'ProductContext' });

export { ProductProvider, useProduct };
